// extracted by css-extract-rspack-plugin
export default {"inputC":"inputC-eRxIvM","button":"button-wec4SC","input":"input-fmaAJa","popover":"popover-ZHYUvb"};